// src/components/strumenti/CadutaTensioneDCFV.js
import React, { useState } from "react";
import { RefreshCw } from "lucide-react";
import { leggiNumero } from "../../utils/numeriStrumenti";

const inp = { padding:"10px 12px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, fontFamily:"'Inter',sans-serif", outline:"none", width:"100%" };
const lbl = { fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:4 };
const RESISTIVITA_RAME = 0.0178;

export default function CadutaTensioneDCFV() {
  const [impp, setImpp] = useState("");
  const [lunghezza, setLunghezza] = useState("");
  const [sezione, setSezione] = useState("6");
  const [vmppStringa, setVmppStringa] = useState("");

  const I = leggiNumero(impp)||0;
  const L = leggiNumero(lunghezza)||0;
  const S = leggiNumero(sezione)||0;
  const V = leggiNumero(vmppStringa)||0;

  const puoCalcolare = I>0 && L>0 && S>0;
  const deltaV = puoCalcolare ? (2*RESISTIVITA_RAME*L*I)/S : null;
  const deltaVPerc = deltaV!==null && V>0 ? (deltaV/V)*100 : null;

  return (
    <div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:12 }}>
        <div>
          <label style={lbl}>Impp stringa (A, da datasheet)</label>
          <input value={impp} onChange={e=>setImpp(e.target.value)} style={inp} placeholder="Es. 10.5"/>
        </div>
        <div>
          <label style={lbl}>Sezione cavo DC (mm²)</label>
          <select value={sezione} onChange={e=>setSezione(e.target.value)} style={inp}>
            {[4,6,10,16].map(s => <option key={s} value={s}>{s} mm²</option>)}
          </select>
        </div>
      </div>
      <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12, marginBottom:16 }}>
        <div>
          <label style={lbl}>Lunghezza cavo (m, solo andata)</label>
          <input value={lunghezza} onChange={e=>setLunghezza(e.target.value)} style={inp} placeholder="Es. 25"/>
        </div>
        <div>
          <label style={lbl}>Vmpp stringa (V) — facoltativo, per la %</label>
          <input value={vmppStringa} onChange={e=>setVmppStringa(e.target.value)} style={inp} placeholder="Es. 690"/>
        </div>
      </div>

      <div style={{ background: deltaVPerc>1 ? "#fef2f2" : "#fff7ed", border:`1px solid ${deltaVPerc>1?"#fca5a5":"#fed7aa"}`, borderRadius:10, padding:"14px 16px", textAlign:"center" }}>
        <div style={{ fontSize:11, color:"#9ca3af", fontWeight:600, marginBottom:4 }}>Caduta di tensione lato DC</div>
        <div style={{ fontSize:22, fontWeight:800, color: deltaVPerc>1 ? "#dc2626" : "#c2410c" }}>
          {deltaV===null ? "—" : `${deltaV.toLocaleString("it-IT",{maximumFractionDigits:2})} V`}
          {deltaVPerc!==null && <span style={{ fontSize:14, marginLeft:8, color:"#9ca3af" }}>({deltaVPerc.toLocaleString("it-IT",{maximumFractionDigits:2})}%)</span>}
        </div>
        {deltaVPerc!==null && deltaVPerc>1 && (
          <div style={{ fontSize:11, color:"#991b1b", marginTop:6 }}>Supera l'1%, valore comunemente preso come buona prassi per il lato DC FV — considerare una sezione maggiore</div>
        )}
      </div>
      <div style={{ fontSize:10, color:"#9ca3af", marginTop:8, textAlign:"center" }}>
        Ogni punto percentuale di caduta è energia persa in calore — non stima la produzione complessiva dell'impianto.
      </div>

      <button onClick={()=>{setImpp("");setLunghezza("");setSezione("6");setVmppStringa("");}}
        style={{ marginTop:12, display:"flex", alignItems:"center", gap:6, fontSize:12, color:"#9ca3af", background:"none", border:"none", cursor:"pointer" }}>
        <RefreshCw size={12}/> Azzera
      </button>
    </div>
  );
}
